import { BrowserRouter } from 'react-router-dom'
import { useEffect } from 'react'
import styles from './App.module.scss'
import Routes from './Routes/Routes'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import WebFont from 'webfontloader'
import config_fonts from './constants/config_fonts'
import { connect } from 'react-redux'
import { IKContext } from 'imagekitio-react'

function App() {
	// Load Google Fonts on component mount
	useEffect(() => {
		WebFont.load(config_fonts)
	}, [])

	return (
		<IKContext urlEndpoint={process.env.REACT_APP_IMAGE_CDN_ENDPOINT}>
			<div className={`${styles.App} foodi-app`}>
				<BrowserRouter>
					<Routes />
					<ToastContainer />
				</BrowserRouter>
			</div>
		</IKContext>
	)
}

const mapStateToProps = (state) => ({ Auth: state.Auth })
export default connect(mapStateToProps)(App)
